import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Workout } from './workout-tracker.model';

@Component({
    selector: 'app-workout-log',
    templateUrl: './workout-log.component.html',
    styleUrls: ['./workout-log.component.scss'],
    standalone: false
})
export class WorkoutLogComponent {
  @Input() workoutLog: Workout[] = [];
  @Output() workoutSelected = new EventEmitter<Workout>();

  onWorkoutClick(w: Workout) {
    this.workoutSelected.emit(w);
  }
}

